// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__3h7s8","icon":"Socials_icon__Immwk"};